module.exports = __webpack_public_path__ + "static/media/mny.eeec7afb.svg";